module.exports = __webpack_public_path__ + "img/bg_768.8a29df71.png";